import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
import router from '@/router'
import Vue from 'vue'

import axios from 'axios'

const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

Vue.prototype.$http = axiosIns

axiosIns.interceptors.request.use((config) => {
  // Eliminar slash final de la URL
  if (config.url && config.url.endsWith('/')) {
    // eslint-disable-next-line no-param-reassign
    config.url = config.url.slice(0, -1)
  }

  // Añadir token de autenticación si está disponible
  const token = localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
  if (token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `${useJwt.jwtConfig.tokenType} ${token}`
  }

  return config
})

axiosIns.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
      localStorage.removeItem('userData')
      localStorage.removeItem('paraIsp')

      if (Vue.prototype.$ability) {
        Vue.prototype.$ability.update(initialAbility)
      }

      router.push({ name: 'login' }).catch(() => {
      })
    }

    return Promise.reject(error)
  },
)

export default axiosIns
